import cta from './sections/cta';
import hero from './sections/hero';
import newsletter from './sections/newsletter';
import plans from './sections/plans';

const translations = {
    page: {
        metaTitle: 'Pakiety',
        metaDescription: 'Pakiety',
    },
    sections: {
        hero,
        plans,
        cta,
        newsletter,
    },
};

export default translations;
